import { Component } from '@angular/core';

@Component({
    selector: 'app-forgot-login',
    templateUrl: './forgot-login.component.html',
    styleUrls: [],
})
export class ForgotLoginComponent{
}
